import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../api/client';
import '../styles/auth.css';

export default function ResetPassword() {
  const [searchParams]    = useSearchParams();
  const [password, setPassword]   = useState('');
  const [confirm, setConfirm]     = useState('');
  const [done, setDone]           = useState(false);
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState('');
  const navigate = useNavigate();

  const token = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 6) { setError('Password must be at least 6 characters'); return; }
    setError('');
    setLoading(true);
    try {
      await authAPI.resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed — the link may have expired');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-card-inner">
            <span className="auth-logo">covo</span>
            <h1 className="auth-heading">Invalid link</h1>
            <p className="auth-sub">This reset link is missing a token.</p>
            <p className="auth-link"><Link to="/forgot-password">Request a new link</Link></p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-card-inner">
          <span className="auth-logo">covo</span>

          {done ? (
            <>
              <h1 className="auth-heading">Password updated!</h1>
              <p className="auth-sub">Your password has been changed successfully.</p>
              <button className="btn-primary" onClick={() => navigate('/login')}>
                Sign in →
              </button>
            </>
          ) : (
            <>
              <h1 className="auth-heading">Set new password</h1>
              <p className="auth-sub">Choose a new password for your account.</p>

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>New password</label>
                  <input
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="At least 6 characters"
                    required
                    autoFocus
                  />
                </div>
                <div className="form-group">
                  <label>Confirm password</label>
                  <input
                    type="password"
                    value={confirm}
                    onChange={e => setConfirm(e.target.value)}
                    placeholder="••••••••"
                    required
                  />
                </div>
                {error && <div className="error-message">{error}</div>}
                <button type="submit" className="btn-primary" disabled={loading}>
                  {loading ? 'Saving…' : 'Set new password'}
                </button>
              </form>

              <p className="auth-link"><Link to="/login">Back to login</Link></p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
